@let type = typeSg();
@let message = messageSg();
@let messageExist = message?.length ?? 0 > 0;

@switch (type) {
  @case ('header') {
    <div class="atn-ds-loader__header">
      <div class="atn-ds-loader__title"></div>
      <div class="atn-ds-loader__subtitle"></div>
    </div>
  }
  @case ('tabs') {
    <div class="atn-ds-loader__tabs"></div>
  }
  @case ('typing') {
    <div class="atn-ds-loader__typing">
      <div class="atn-ds-loader__dot"></div>
      <div class="atn-ds-loader__dot"></div>
      <div class="atn-ds-loader__dot"></div>
    </div>
  }
  @case ('widget') {
    <div class="atn-ds-loader__widget">
      <div class="atn-ds-loader__widget-header">
        <div class="atn-ds-loader__subtitle"></div>
      </div>
      <div class="atn-ds-loader__widget-body">
        <div class="atn-ds-loader__spinner"></div>
      </div>
    </div>
  }

  @case ('page') {
    <div class="atn-ds-loader__page">
      <div class="atn-ds-loader__spinner"></div>
      @if (messageExist) {
        <div class="atn-ds-loader__message">
          {{ message }}
        </div>
      }
    </div>
  }

  @case ('table') {
    <div class="atn-ds-loader__table"></div>
  }

  @case ('default') {
    <div class="atn-ds-loader__spinner-wrapper">
      <div class="atn-ds-loader__spinner"></div>
      @if (messageExist) {
        <div class="atn-ds-loader__message">
          {{ message }}
        </div>
      }
    </div>
  }
}
